import { EArticleClass, TArticleDetail } from 'shared/models';
import { ClickPosition, ClickPositionPrefix } from '~/utils/click-position';
import { usePageActive } from '~/utils/active/use-page-active';
import { useCallback } from 'react';
import { Article } from 'shared/models/legacy';

export const useActiveToArticle = (
  article: TArticleDetail,
): ((position: ClickPosition | [ClickPositionPrefix, ClickPosition], id?: string) => void) => {
  const active = usePageActive();

  return useCallback(
    (position, id) => {
      const {
        articleClass,
        groupId,
        author: { userId },
      } = article;
      const enterPosition = Array.isArray(position) ? position[0] + position[1] : position;

      active({
        schemaOption: {
          pageType: articleClass === EArticleClass.VIDEO ? 'video' : 'article',
          groupId,
          authorId: userId,
        },
        ampExtra: {
          enter_position: enterPosition,
          enter_page_click_id: id || null,
        },
      });
    },
    [active, article],
  );
};

export const useActiveToArticleAuthor = (
  article: TArticleDetail,
): ((position: ClickPosition | [ClickPositionPrefix, ClickPosition], id?: string) => void) => {
  const active = usePageActive();

  return useCallback(
    (position, id) => {
      const {
        author: { userId },
      } = article;
      const enterPosition = Array.isArray(position) ? position[0] + position[1] : position;

      active({
        schemaOption: {
          pageType: 'user',
          userId,
        },
        ampExtra: {
          enter_position: enterPosition,
          enter_page_click_id: id || null,
        },
      });
    },
    [active, article],
  );
};

export const useActiveToArticleBySimpleArticle = (
  article: Article,
): ((position: ClickPosition | [ClickPositionPrefix, ClickPosition], id?: string) => void) => {
  const active = usePageActive();

  return useCallback(
    (position, id) => {
      const {
        articleClass,
        groupId,
        author: { userId },
      } = article;
      const enterPosition = Array.isArray(position) ? position[0] + position[1] : position;

      active({
        schemaOption: {
          pageType: articleClass === EArticleClass.VIDEO ? 'video' : 'article',
          groupId,
          authorId: userId,
        },
        ampExtra: {
          enter_position: enterPosition,
          enter_page_click_id: id || null,
        },
      });
    },
    [active, article],
  );
};
